import { outputFactory } from '@/helpers/std-out/output'

/** Standard output logging interface for the CLI */
export const output = {
  error: outputFactory('error'),
  warn: outputFactory('warn'),
  info: outputFactory('info'),
}
